/*
# -----------------------------------------------------------------------------
# Component: accountsListMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 02/April/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const accountsListMixin = {
  data() {
    return {
      totalItems: 0,
      totalItemsAM: 0,
      totalItemsGL: 0,
      totalItemsMD: 0,
      totalItemsCM: 0,
      totalItemsNonTrade: 0,
      itemsAM: [],
      itemsGL: [],
      itemsMD: [],
      itemsCM: [],
      itemsNonTrade: [],
      selectedPage: 0,
      selectedAccountsColumns: ['branch', 'type', 'docNo', 'acctNo', 'fund', 'suffix', 'tranDate', 'curr', 'netAmount', 'osBalance', 'policyNo', 'claimNo', 'insdName'],
      accountsColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'type' },
        { text: 'Acct. No.', value: 'acctNo' },
        { text: 'Doc. No.', value: 'docNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'suffix' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Curr', value: 'curr' },
        { text: 'Net Amount', value: 'netAmount' },
        { text: 'OS Balance', value: 'osBalance' },
        { text: 'Policy', value: 'policyNo' },
        { text: 'Claim', value: 'claimNo' },
        { text: 'Insured Name', value: 'insdName' }
      ],
      selectedGLColumns: ['glJrnl', 'glAcctNo', 'glPeriod', 'tranDate', 'curr', 'glAmount', 'glLocAmt'],
      glColumns: [
        { text: 'Jrnl', value: 'glJrnl' },
        { text: 'GL Acct. No.', value: 'glAcctNo' },
        { text: 'Period', value: 'glPeriod' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Curr', value: 'curr' },
        { text: 'Amount', value: 'glAmount' },
        { text: 'Local Amount', value: 'glLocAmt' }
      ],
      selectedMDColumns: ['mdJournalNo', 'mdDate', 'mdBaseTrans', 'acctNo', 'mdSelectTrans', 'mdAmt', 'mdLocAmt', 'mdMchBy', 'mdMchProg'],
      mdColumns: [
        { text: 'Jrnl', value: 'mdJournalNo' },
        { text: 'Matched Date', value: 'mdDate' },
        { text: 'Base Transaction', value: 'mdBaseTrans' },
        { text: 'Acct No.', value: 'acctNo' },
        { text: 'Select Transaction', value: 'mdSelectTrans' },
        { text: 'Amount', value: 'mdAmt' },
        { text: 'Local Amount', value: 'mdLocAmt' },
        { text: 'Matched By', value: 'mdMchBy' },
        { text: 'Matched Prog', value: 'mdMchProg' }
      ],
      selectedCommColumns: ['cmType', 'cmVoucher', 'cmBillAcctNo', 'cmOvrdAcctNo', 'cmPolRenEndt', 'cmCommAmt', 'cmPaidDate', 'cmPaidBy'],
      commColumns: [
        { text: 'Type', value: 'cmType' },
        { text: 'Voucher', value: 'cmVoucher' },
        { text: 'Bill Acct No.', value: 'cmBillAcctNo' },
        { text: 'Overriding Acct No.', value: 'cmOvrdAcctNo' },
        { text: 'Policy', value: 'cmPolRenEndt' },
        { text: 'Commission', value: 'cmCommAmt' },
        { text: 'Paid Date', value: 'cmPaidDate' },
        { text: 'Paid by', value: 'cmPaidBy' }
      ],
      selectedNonTradeColumns: ['ntBranch', 'ntType', 'ntDocNo', 'ntAddrTo', 'ntFund', 'ntSuffix', 'ntTranDate', 'ntCurr', 'ntNetAmt', 'ntLocal'],
      nonTradeColumns: [
        { text: 'Branch', value: 'ntBranch' },
        { text: 'Type', value: 'ntType' },
        { text: 'Doc No.', value: 'ntDocNo' },
        { text: 'Addressed To', value: 'ntAddrTo' },
        { text: 'Fund', value: 'ntFund' },
        { text: 'Suffix', value: 'ntSuffix' },
        { text: 'Tran Date', value: 'ntTranDate' },
        { text: 'Curr', value: 'ntCurr' },
        { text: 'Net Amount', value: 'ntNetAmt' },
        { text: 'Local', value: 'ntLocal' }
      ],
      paginationAM: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationGL: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationMD: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationCM: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationNonTrade: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      firstTimeCalling: true
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listAccountsHeaders() {
      let result = []
      for (const selectedAccountsColumn of this.selectedAccountsColumns) {
        let findCol = this.accountsColumns.find(a => selectedAccountsColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listGLHeaders() {
      let result = []
      for (const selectedGLColumn of this.selectedGLColumns) {
        let findCol = this.glColumns.find(a => selectedGLColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listMDHeaders() {
      let result = []
      for (const selectedMDColumn of this.selectedMDColumns) {
        let findCol = this.mdColumns.find(a => selectedMDColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listCommHeaders() {
      let result = []
      for (const selectedCommColumn of this.selectedCommColumns) {
        let findCol = this.commColumns.find(a => selectedCommColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listNonTradeHeaders() {
      let result = []
      for (const selectedNonTradeColumn of this.selectedNonTradeColumns) {
        let findCol = this.nonTradeColumns.find(a => selectedNonTradeColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'paginationAM': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    },
    'paginationGL': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    },
    'paginationMD': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    },
    'paginationCM': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    },
    'paginationNonTrade': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    }
  },
  mounted() {
    this.doAction()
    this.doTranType()
    // this.getBranchList()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
